var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"31.9998","cy":"32.0032","r":"23.2698","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("circle",{"cx":"24","cy":"36.3462","r":"6","stroke":"currentColor","strokeLinecap":"round","strokeDasharray":"3 3","key":1}),React.createElement("circle",{"cx":"32","cy":"22.9717","r":"6","stroke":"currentColor","strokeLinecap":"round","strokeDasharray":"3 3","key":2}),React.createElement("circle",{"cx":"40","cy":"36.3462","r":"6","stroke":"currentColor","strokeLinecap":"round","strokeDasharray":"3 3","key":3})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 65"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
